import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import { BUTTON_TYPES } from 'constants/button'
import Button from 'components/common/button'
import styles from './share-page.scss'

const SharePage = ({ t, url, title, text, customEvent }) => {
  const [isActive, setIsActive] = useState(false)

  const handleSharePage = async () => {
    customEvent?.()
    if (navigator.share) {
      try {
        await navigator.share({
          text,
          title,
          url: url ?? window.location.href,
        })
      } catch (error) {
        // eslint-disable-next-line
        console.error('Error sharing:', error)
      }
    }
  }

  useEffect(() => {
    if (navigator.share) {
      setIsActive(true)
    }
  }, [setIsActive])

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <div className="share-page">
        <Button
          disabled={!isActive}
          type={BUTTON_TYPES.text}
          onClick={handleSharePage}
        >
          <Icon
            alt="share button"
            src={ICONS.shareLink}
            size={ICON_SIZE.medium}
          />
          {hasLocizeTranslation(t, 'SHARE', 'SHARE')}
        </Button>
      </div>
    </React.Fragment>
  )
}

SharePage.defaultProps = {
  text: '',
  title: '',
  url: null,
  customEvent: null,
}

SharePage.propTypes = {
  // component props
  url: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  customEvent: PropTypes.func,
  t: PropTypes.func.isRequired,
}

export default compose(withI18next())(SharePage)
